/* istanbul ignore file */
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from 'App';
import * as serviceWorker from 'serviceWorker';
import moment from 'moment-timezone';

moment.tz.setDefault('Africa/Casablanca');
const root = createRoot(document.getElementById('root'));

root.render(<App />);

serviceWorker.unregister();
